<div class="pointer-events-none fixed bottom-6 right-6 z-[120] flex w-[360px] max-w-[calc(100vw-2rem)] flex-col gap-3">

  @for (toast of toastService.items(); track trackById($index, toast)) {

    <div
      class="pointer-events-auto flex min-h-[58px] justify-between gap-3 rounded-[4px] border border-l-[6px] bg-white px-4 py-3"
      [class.items-center]="!toast['title'] && !toast['details']?.length"
      [class.items-start]="toast['title'] || toast['details']?.length"
      [style.borderColor]="getFrameColor(toast.type)"
      [style.borderLeftColor]="getAccentColor(toast.type)"
      role="status"
      aria-live="polite"
    >

      <div
        class="flex min-w-0 flex-1 gap-3"
        [class.items-center]="!toast['title'] && !toast['details']?.length"
        [class.items-start]="toast['title'] || toast['details']?.length"
      >

        <!-- ICON BOX -->
        <div
          class="flex h-8 w-8 shrink-0 items-center justify-center rounded-[10px]"
          [class.mt-0.5]="toast['title'] || toast['details']?.length"
          [style.backgroundColor]="getIconBgColor(toast.type)"
        >
          <span class="inline-flex items-center justify-center" [innerHTML]="renderStatusIcon(toast.type)"></span>
        </div>

        <!-- TEXT -->
        <div class="flex min-w-0 flex-col gap-0.5 w-full">
          @if (toast['title']) {
            <span class="text-[14px] font-semibold leading-[1.2] text-[#0F172A] break-words">{{ toast['title'] }}</span>
          }
          <span class="text-[12px] leading-[1.5] text-[#1E293B] break-words whitespace-normal">
            {{ toast.message }}
          </span>
          @if (toast['details']?.length) {
            <ul class="mt-1 space-y-0.5 pl-3">
              @for (detail of toast['details']; track $index) {
                <li class="list-disc text-[11px] leading-[1.4] text-[#475569]">
                  @if (isDetailString(detail)) {
                    {{ detail }}
                  } @else {
                    <span>
                      @if (detail.field) {
                        <strong>{{ detail.field }}:</strong>
                      }
                      {{ detail.message }}
                    </span>
                  }
                </li>
              }
            </ul>
          }
        </div>

      </div>

      <!-- CLOSE BUTTON -->
      <button
        type="button"
        class="ml-1 flex h-8 w-8 shrink-0 items-center justify-center rounded"
        (click)="toastService.dismiss(toast.id)"
        aria-label="Dismiss notification"
      >
        <span class="inline-flex items-center justify-center" [innerHTML]="renderCloseIcon()"></span>
      </button>

    </div>

  }
</div>
